import { render, staticRenderFns } from "./jessibuca.vue?vue&type=template&id=2aa74d2f"
import script from "./jessibuca.vue?vue&type=script&lang=js"
export * from "./jessibuca.vue?vue&type=script&lang=js"
import style0 from "./jessibuca.vue?vue&type=style&index=0&id=2aa74d2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports